import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ContactsService } from 'src/app/cms/contacts/contacts.service';

@Injectable({
  providedIn: 'root'
})
export class ContactsResolve implements Resolve<any> {

  constructor(
    private cs: ContactsService,
  ) { }

  resolve(route: ActivatedRouteSnapshot){
    let params = {
      ...route.params,
      ac_group: route.parent.params.id
    }
    return this.cs.updateContacts(params)
  }
}
